import { mapUser } from '../API/UserApi';
import { User } from './User';

export class Notification {
  id: string;
  userId: string;
  message: string;
  link: string;
  createdAt: Date;
  readAt: Date | undefined;
  showModal: boolean;
  user?: User;

  constructor(data: any = {}) {
    this.id = data.id;
    this.userId = data.userId;
    this.message = data.message;
    this.link = data.link;
    this.createdAt = new Date(data.createdAt);
    this.readAt = data.readAt ? new Date(data.readAt) : undefined;
    this.showModal = data.showModal;
    this.user = data.user ? mapUser(data.user) : undefined;
  }
}
